<template lang="pug">
	.side-navigation-menu(@click="forwardClick")
		slot
		.menu-container.flex-col.space.full-height
			dx-tree-view(
				v-if="$auth.authenticated()"
				expand-event="click"
				width="100%"
				selection-mode="single"
				key-expr="path"
				:select-nodes-recursive="true"
				:select-by-click="true"
				:items="menuItems"
				:ref="treeViewRef"
				@initialized="handleMenuInitialized"
				@item-click="handleItemClick"
				@selection-changed="handleSelectionChange"
				@content-ready="handleSelectionChange"
			)
			.quote-menu-switcher.flex-row.space-large.justify(v-if="$auth.hasAccessToQuote()")
				.full-width(@click="showQuoteMenu = !showQuoteMenu", v-if="!compactMode") Quote menu {{showQuoteMenu ? 'on' : 'off'}}
				DxSwitch(:value.sync="showQuoteMenu")
</template>

<script>
import _ from 'lodash';
import DxTreeView from 'devextreme-vue/ui/tree-view';
import { DxSwitch } from 'devextreme-vue/switch';

const treeViewRef = 'treeViewRef';

export default {
	components: {
		DxTreeView, DxSwitch
	},
	props: {
		items: Object,
		selectedItem: String,
		compactMode: Boolean
	},
	data() {
		return {
			treeViewRef,
			showQuoteMenu: false
		};
	},
	computed: {
		menuItems() {
			const filterItems = (items) => {
				let filtered = items.filter(f => f.hidden == null || !f.hidden());

				filtered.map(f => {
					if (f.items) {
						f.items = filterItems(f.items);
					}
				});

				return filtered;
			};

			const items = filterItems(_.cloneDeep(this.$auth.hasAccessToQuote() && this.showQuoteMenu ? this.items.quote : this.items.default));
			return items;
		}
	},
	watch: {
		$route() {
			this.updateSelection();
		},
		compactMode() {
			if (this.compactMode) {
				this.treeView.collapseAll();
			}
		}
	},
	mounted() {
		this.treeView = this.$refs[treeViewRef] && this.$refs[treeViewRef].instance;
		this.updateSelection();
		if (this.compactMode) {
			this.treeView.collapseAll();
		}
	},
	methods: {
		forwardClick(...args) {
			this.$emit('click', args);
		},

		handleMenuInitialized(event) {
			event.component.option('deferRendering', false);
		},

		handleItemClick(e) {
			if (!e.itemData.path || this.compactMode) {
				return;
			}

			this.$router.push(e.itemData.path);

			const pointerEvent = e.event;
			pointerEvent.stopPropagation();
		},

		handleSelectionChange(e) {
			this.updateSelection();
			const nodeClass = 'dx-treeview-node';
			const selectedClass = 'dx-state-selected';
			const leafNodeClass = 'dx-treeview-node-is-leaf';
			const element = e.element;

			const rootNodes = element.querySelectorAll(
				`.${nodeClass}:not(.${leafNodeClass})`
			);
			Array.from(rootNodes).forEach(node => {
				node.classList.remove(selectedClass);
			});

			let selectedNode = element.querySelector(
				`.${nodeClass}.${selectedClass}`
			);

			while (selectedNode && selectedNode.parentElement) {
				if (selectedNode.classList.contains(nodeClass)) {
					selectedNode.classList.add(selectedClass);
				}
				selectedNode = selectedNode.parentElement;
			}
		},

		updateSelection() {
			if (!this.treeView) {
				return;
			}

			this.treeView.selectItem(this.$route.path);
		}
	},
};
</script>

<style lang="scss">
@import "../dx-styles-params.scss";
@import "../themes/generated/variables.additional.scss";

.side-navigation-menu {
	display: flex;
	flex-direction: column;
	min-height: 100%;
	height: 100%;
	width: 250px !important;

	.quote-menu-switcher {
		color: rgba(255,255,255,0.3);
		opacity: 0.5;
		padding: 10px;

		&:hover {
			cursor: pointer;
			opacity: 1;
		}
	}

	.menu-container {
		min-height: 100%;
		display: flex;
		flex: 1;

		.dx-treeview {
			// ## Long text positioning
			white-space: nowrap;
			// ##

			// ## Icon width customization
			.dx-treeview-item {
			padding-left: 0;
				padding-right: 0;

				.dx-icon {
					width: $side-panel-min-width !important;
					margin: 0 !important;
				}
			}
			// ##

			// ## Arrow customization
			.dx-treeview-node {
				padding: 0 0 !important;
			}

			.dx-treeview-toggle-item-visibility {
				right: 10px;
				left: auto;
			}

			.dx-rtl .dx-treeview-toggle-item-visibility {
				left: 10px;
				right: auto;
			}
			// ##

			// ## Item levels customization
			.dx-treeview-node {
				&[aria-level="1"] {
					font-weight: bold;
					border-bottom: 1px solid $base-border-color;
				}

				&[aria-level="2"] .dx-treeview-item-content {
					font-weight: normal;
					padding: 0 $side-panel-min-width;
				}
			}
			// ##
		}

		// ## Selected & Focuced items customization
		.dx-treeview {
			.dx-treeview-node-container {
				.dx-treeview-node {
					&.dx-state-selected:not(.dx-state-focused) > .dx-treeview-item {
						background: transparent;
					}

					&.dx-state-selected > .dx-treeview-item * {
						color: $base-accent;
					}

					&:not(.dx-state-focused) > .dx-treeview-item.dx-state-hover {
						background-color: lighten($base-bg, 4);
					}
				}
			}
		}

		.dx-theme-generic .dx-treeview {
			.dx-treeview-node-container
			.dx-treeview-node.dx-state-selected.dx-state-focused
			> .dx-treeview-item
			* {
				color: inherit;
			}
		}
	}
}
</style>
